
import { Component, ViewChild } from '@angular/core';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { TranslateModule } from '@ngx-translate/core';
import { ParkingCardGridComponent } from "../shared/parking-card-grid.component";
import { FormsModule } from '@angular/forms';
import { ParkingCardService } from '../shared/parking-card.service';

@Component({
  selector: 'app-parking-card-user',
  templateUrl: './parking-card-user.component.html',
  styleUrls: ['./parking-card-user.component.scss'],
  imports: [TitleBarComponent, TranslateModule, ParkingCardGridComponent, FormsModule, ParkingCardGridComponent]
})
export class ParkingCardUserComponent {

  @ViewChild(ParkingCardGridComponent)
  private parkingCardGridComponent: ParkingCardGridComponent;

  public get issuedToMe(): boolean {
    return this.parkingCardService.issuedToMe;
  }

  public set issuedToMe(value: boolean) {
    this.parkingCardService.issuedToMe = value;
  }

  constructor(private parkingCardService: ParkingCardService) {
    this.parkingCardService.resetService();
  }

  public changeView(): void {
    this.parkingCardGridComponent?.refreshGrid();
  }

}
